var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "uk-position-bottom-left printer-memo" }, [
    _c("div", { staticClass: "uk-position-relative" }, [
      _c("div", { staticClass: "printer-memo__title" }, [_vm._v("メモ")]),
      _vm.memo
        ? _c("div", {
            staticClass: "printer-memo__body",
            staticStyle: { "white-space": "pre-wrap" },
            domProps: { textContent: _vm._s(_vm.memo) }
          })
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }